import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  resetSelectedWallets,
  setRedumptionRatio,
} from "../store/Profile/ProfileActions";
import {
  deleteFromCart,
  setOrderTypeModal,
  setWalletRedeemed,
  updateCart,
} from "../store/Cart/CartActions";
import { v4 as uuidv4 } from "uuid";
import { dispatchErrorMessageAsWarning } from "../utils/Shared";
import moment from "moment";
import useSortHook from "./useSortHook";
import usePriceSummary from "./usePriceSummary";

const useWalletPoints = () => {
  const cart = useSelector((state) => state.cart);
  const { userData, isMobileApp } = useSelector((state) => state.hotel);
  const { redumptionRatio, walletPointsLimitReached, usedWalletPoints } =
    useSelector((state) => state.profile);
  const { checkProductAvailability, formatDateToCheck } = useSortHook();
  const [currentTime, setCurrentTime] = useState(moment());
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);


  // const getWalletRedemption = () => {
  //   let obj = {};

  //   if (cart?.checkoutDetails?.orderType === "DELIVERY") {
  //     obj = userData?.redumption_ratio?.find(
  //       (rat) => rat?.order_type === "ONLINE_DELIVERY"
  //     );
  //   } else if (cart?.checkoutDetails?.orderType === "PICKUP") {
  //     obj = userData?.redumption_ratio?.find(
  //       (rat) => rat?.order_type === "ONLINE_PICKUP"
  //     );
  //   } else if (cart?.checkoutDetails?.orderType == null) {
  //     dispatch(setOrderTypeModal(true));
  //   }
  //   return obj;
  // };

 

  const getWalletRedemption = () => {
    let obj = {};

    // Early return if userData is not available
    if (!userData || !userData?.redumption_ratio) {
      return obj;
    }

    if (cart?.checkoutDetails?.orderType === "DELIVERY") {
      if (isMobileApp) {
        obj = userData?.redumption_ratio?.find(
          (rat) => rat?.order_type === "ONLINE_APP_DELIVERY"
        );
      } else {
        obj = userData?.redumption_ratio?.find(
          (rat) =>
            rat?.order_type === "ONLINE_DELIVERY" 
        );
      }
    } else if (cart?.checkoutDetails?.orderType === "PICKUP") {
      if (isMobileApp) {
        obj = userData?.redumption_ratio?.find(
          (rat) => rat?.order_type === "ONLINE_APP_PICKUP"
        );
      } else {
        obj = userData?.redumption_ratio?.find(
          (rat) =>
            rat?.order_type === "ONLINE_PICKUP" 
        );
      }
    } else if (cart?.checkoutDetails?.orderType == null) {
      dispatch(setOrderTypeModal(true));
    }

    return obj;
  };

  const getPriceWithAvailableWalletPoints = (points) => {
    let price = 0;
    const redump = getWalletRedemption();
    if (redump) {
      price = points / redump?.ratio_points;
    }
    const roundedPrice = price;

    return roundedPrice;
  };

  const isPointMoreThanMax = (points) => {
    if (getWalletRedemption()?.maximum_consumable_points < points) {
      return false;
    } else {
      return true;
    }
  };

  const isPointLessThanMin = (points) => {
    if (getWalletRedemption()?.min_consumable_points > points) {
      return false;
    } else {
      return true;
    }
  };

  const isPointIsMoreThanAvailable = (points) => {
    if (points > userData?.wallet_points) {
      return false;
    } else {
      return true;
    }
  };

  const getWalletPointsFromCartPrice = (price, points) => {
    let walletPoints = 0;
    let walletPrice = 0;
    let status = false;
    if (getWalletRedemption()?.ratio_points) {
      walletPoints = price * getWalletRedemption()?.ratio_points;
      walletPrice = points / getWalletRedemption()?.ratio_points;
      status = true;

      return { status, walletPoints, walletPrice };
    }
  };

  const isWalletLimitReached = (usedWalletPoints, currentUsed) => {
    const redemption = getWalletRedemption();
    const total = usedWalletPoints + currentUsed;

    // Return true if total is NaN or redemption is empty
    if (isNaN(total) || !redemption || Object.keys(redemption).length === 0) {
      return false;
    }

    return (
      total >= userData?.wallet_points ||
      (redemption?.maximum_consumable_points &&
        total >= redemption.maximum_consumable_points)
    );
  };

  const calculateTotalPrice = (filteredProds) => {
    let totalPrice = 0;

    filteredProds?.forEach((prod) => {
      let productPrice = prod.sale_price; // Default to sale_price

      // Check if a size is specified and sizes array is not empty
      if (prod?.size && prod?.sizes?.length > 0) {
        const sizeDetail = prod?.sizes.find((size) => size?.id == prod?.size);
        if (sizeDetail) {
          productPrice = sizeDetail.size_amount; // Use size_amount if available
        }
      }

      // Add the product price and addOns price to the total
      totalPrice += productPrice * prod?.count;
    });

    return totalPrice;
  };

  const getWalletPointsFromCartProducts = (points) => {
    let walletPoints = 0;
    let walletPrice = 0;
    let status = false;

    const filteredProds = filterCartProductsLoyality(cart?.data);
    const totalPrice = calculateTotalPrice(filteredProds);
    walletPoints = totalPrice * getWalletRedemption()?.ratio_points;
    walletPrice = points / getWalletRedemption()?.ratio_points;
    status = true;

    if (totalPrice > 0) {
      if (totalPrice < walletPrice) {
        const adjustedWalletPoints =
          totalPrice * getWalletRedemption()?.ratio_points;
        // Calculate walletPrice based on the adjusted walletPoints
        const adjustedWalletPrice =
          adjustedWalletPoints / getWalletRedemption()?.ratio_points;

        return {
          status: false,
          walletPoints: adjustedWalletPoints,
          walletPrice: adjustedWalletPrice,
        };
      } else {
        return { status: true, walletPoints, walletPrice };
      }
    } else {
      return { status: false, walletPoints, walletPrice };
    }
  };

  // const getWalletPointsFromCartProducts = (points) => {
  //   let walletPoints = 0;
  //   let walletPrice = 0;
  //   let status = false;

  //   const filteredProds = filterCartProductsLoyality(cart?.data);
  //   const totalPrice = calculateTotalPrice(filteredProds);
  //   if (getWalletRedemption()?.ratio_points) {
  //     walletPoints = totalPrice * getWalletRedemption()?.ratio_points;
  //     walletPrice = points / getWalletRedemption()?.ratio_points;
  //     status = true;

  //     return { status, walletPoints, walletPrice };
  //   } else {
  //     return { status: false, walletPoints, walletPrice };
  //   }
  // };

  const PointsUsedForType2 = () => {
    let status = false;
    let points = 0;
    let amount = 0;

    if (cart?.data && cart.data.length > 0) {
      cart.data.forEach((item) => {
        if (item.walletType === 2) {
          amount += Number(item.walletAmount);
          points += Number(item.walletUsedForProduct);
          status = true;
        }
      });
    }

    return { status, points, amount };
  };

  const PointsToRedeemIfMax = (points) => {
    let redeemablePoints = 0;
    let redum = getWalletRedemption();

    // if (cart?.discountType !== "wallet") {
   
    if (!getWalletPointsFromCartProducts(points)?.status) {
      if (!PointsUsedForType2()?.status) {
        if (
          getWalletPointsFromCartProducts(points)?.walletPoints >
            redum?.maximum_consumable_points &&
          getWalletPointsFromCartProducts(points)?.walletPoints >
            redum?.min_consumable_points
        ) {
          redeemablePoints = redum?.maximum_consumable_points;
        } else {
          redeemablePoints =
            getWalletPointsFromCartProducts(points)?.walletPoints;
        }
      } else {
        if (
          getWalletPointsFromCartProducts(points)?.walletPoints >
          redum?.maximum_consumable_points - PointsUsedForType2()?.points
        ) {
          redeemablePoints =
            redum?.maximum_consumable_points - PointsUsedForType2()?.points;
        } else {
          redeemablePoints =
            getWalletPointsFromCartProducts(points)?.walletPoints;
        }
      }
    } else if (
      points >
        redum?.maximum_consumable_points - PointsUsedForType2()?.points &&
      getWalletPointsFromCartProducts(points)?.status
    ) {
      redeemablePoints =
        redum?.maximum_consumable_points - PointsUsedForType2()?.points;
    } else {
      redeemablePoints = points;
    }
    // }
    const roundedWallet = redeemablePoints;
    return roundedWallet;
  };

  const getPriceTotalDiscountFromCart = () => {
    let total = 0;
    if (cart?.data && cart?.data?.length > 0) {
      cart?.data?.map((item) => {
        if (item?.walletAmount) {
          total += item?.walletAmount;
        }
      });
    }
    return total;
  };

  const getWalletPointsFromPrice = (price) => {
    let points = 0;
    if (getWalletRedemption()?.ratio_points) {
      points = price * getWalletRedemption()?.ratio_points;
    }
    return points;
  };

  const checkIsLoyalityProdCanApply = (product, size, count) => {
    let price = product?.sale_price;
    if (size) {
      const sizeObj = product?.sizes?.find((si) => si?.id == size);
      if (sizeObj) {
        price = sizeObj.size_amount;
      }
    }
    const currentUsingWalletPoints = getWalletPointsFromPrice(price * count);
    if (user) {
      if (
        usedWalletPoints + currentUsingWalletPoints <=
        getWalletRedemption()?.maximum_consumable_points
      ) {
        if (
          getWalletPointsFromPrice(
            getPriceWithAvailableWalletPoints(userData?.wallet_points)
          ) -
            usedWalletPoints >=
          getWalletPointsFromPrice(price * count)
        ) {
          if (
            getWalletPointsFromPrice(price * count) <=
              getWalletRedemption()?.maximum_consumable_points &&
            getWalletPointsFromPrice(price * count) >=
              getWalletRedemption()?.min_consumable_points
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const getWalletPointsFromProductPrice = (price) => {
    const walletPoints = price * getWalletRedemption()?.ratio_points;

    return walletPoints;
  };

  const filterCartProductsLoyality = (array) => {
    const filteredArray = array?.filter(
      (item) =>
        !item?.combo_id &&
        !item?.isWalletRedeemed &&
        item?.loyalty_creremovdit_disable != 1
    );
    return filteredArray;
  };

  const checkIsProductLoyalityApplied = () => {
    const isApplied = cart?.data?.some(
      (item) => item.isWalletRedeemed === true
    );
    return isApplied;
  };

  const resetWalletProducts = (type) => {
    if (type == 1) {
      const itemsWithoutCombo = cart?.data?.filter((dat) => !dat?.combo_id);
      const itemsWithTypeOne = itemsWithoutCombo?.filter(
        (item) => item?.walletType == 1 && !item?.isLoyaltyAddedProduct
      );
      if (itemsWithTypeOne) {
        itemsWithTypeOne?.forEach((prod) => {
          dispatch(
            updateCart({
              ...prod,
              isWalletRedeemed: false,
              walletDiscount: 0,
              walletAmount: 0,
              walletType: 0,
              walletUsedForProduct: 0,
            })
          );
        });
      }
      // dispatch(resetSelectedWallets());
      // dispatch(setWalletRedeemed(false));
      // dispatchErrorMessageAsWarning({
      //   title: "Warning",
      //   message: "Sorry, removed wallet discount applied",
      // });
    } else if (type === 2) {
      const itemsWithoutCombo = cart?.data?.filter((dat) => !dat?.combo_id);
      const itemsWithTypeOne = itemsWithoutCombo?.filter(
        (item) => item?.isWalletRedeemed && !item?.isLoyaltyAddedProduct
      );
      if (itemsWithTypeOne) {
        itemsWithTypeOne?.forEach((prod) => {
          dispatch(
            updateCart({
              ...prod,
              isWalletRedeemed: false,
              walletDiscount: 0,
              walletAmount: 0,
              walletType: 0,
              walletUsedForProduct: 0,
            })
          );
        });
        dispatch(resetSelectedWallets());
      }
      dispatch(setWalletRedeemed(false));
      // dispatchErrorMessageAsWarning({
      //   title: "Warning",
      //   message: "Sorry, removed wallet discount for products applied",
      // });
    } else if (type === 3) {
      const itemsWithoutCombo = cart?.data?.filter((dat) => !dat?.combo_id);
      const itemsWithTypeOne = itemsWithoutCombo?.filter(
        (item) => item?.isWalletRedeemed
      );
      if (itemsWithTypeOne) {
        itemsWithTypeOne?.forEach((prod) => {
          dispatch(
            updateCart({
              ...prod,
              isWalletRedeemed: false,
              walletDiscount: 0,
              walletAmount: 0,
              walletType: 0,
              walletUsedForProduct: 0,
            })
          );
        });
        dispatch(resetSelectedWallets());
      }
      dispatch(setWalletRedeemed(false));
      // dispatchErrorMessageAsWarning({
      //   title: "Warning",
      //   message: "Sorry, removed wallet discount for products applied",
      // });
    }
  };

  const checkIsWalletDiscountTypeIsOne = () => {
    if (cart?.data && cart?.data?.length > 0) {
      return cart?.data?.some((obj) => obj?.walletType === 1);
    }
  };

  const walletPointsOtherThanProduct = () => {
    let total = 0;
    if (cart?.data && cart?.data?.length > 0) {
      cart?.data?.map((item) => {
        if (item?.walletType == 1) {
          total += item?.walletUsedForProduct;
        }
      });
    }
    return total;
  };

  const walletPointsFromType2 = () => {
    let total = 0;
    if (cart?.data && cart?.data?.length > 0) {
      cart?.data?.map((item) => {
        if (item?.isWalletRedeemed) {
          if (item?.walletType) {
            total += item?.walletUsedForProduct;
          }
        }
      });
    }
    return total;
  };

  const hasWalletType2 = useMemo(() => {
    return cart?.data?.some((item) => item?.walletType === 2) || false;
  }, [cart?.data]);

  const walletAmountOtherThanProd = () => {
    let total = 0;
    if (cart?.data && cart?.data?.length > 0) {
      cart?.data?.map((item) => {
        if (item?.walletType == 1) {
          const amount = parseFloat(item?.walletAmount);
          if (!isNaN(amount)) {
            total += amount;
          }
        }
      });
    }
    return total;
  };

  function splitDigits(value) {
    // Convert the value to a number if it's not already
    const numberValue = parseFloat(value);

    // Check if the value is a valid number
    if (!isNaN(numberValue)) {
      // Convert the number to a string and split it at the decimal point
      const parts = numberValue.toFixed(2).toString().split(".");

      // If there are two parts (integer and decimal)
      if (parts.length === 2) {
        return parts[1]; // Return the decimal part
      }
    }

    // If value is not a valid number or doesn't have decimal part, return empty string
    return "";
  }

  const RemoveItemCoupon = (coupon) => {
    if (coupon?.items?.length > 0) {
      cart?.data?.forEach((category) => {
        if (category?.isAutoAdded) {
          dispatch(deleteFromCart(category));
        }
        // else {
        //   dispatch(
        //     updateCart({
        //       ...category, // Pass the selected item's details

        //       categoryId: category.categoryId,
        //     })
        //   );
        // }
      });
    }
  };
  const removeFreeItems = () => {
    const itemsToRemove = cart?.data?.filter(
      (category) => category?.isAutoAdded || category?.freeCount > 0
    );

    itemsToRemove?.forEach((item) => {
      dispatch(deleteFromCart(item));
    });
  };

  const removeAllFreeItems = () => {
    const itemsToRemove = cart?.data?.filter(
      (category) =>
        category?.isAutoAdded ||
        category?.freeCount > 0 ||
        category?.isWalletRedeemed
    );

    itemsToRemove?.forEach((item) => {
      dispatch(deleteFromCart(item));
    });
  };

  const getTotalWalletPoints = () => {
    let total = 0;

    cart?.data?.map((item) => {
      if (item?.walletUsedForProduct) {
        total += item?.walletUsedForProduct;
      }
    });
    return total;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment());
    }, 1000);

    // Clear interval on component unmount
    return () => clearInterval(interval);
  }, []);

  // Function to calculate subtotal excluding coupon-added products
  const calculateManualProductsSubtotal = (cartData, currentSubtotal) => {
    if (!cartData || !Array.isArray(cartData)) {
      return currentSubtotal;
    }
    
    // Filter out products that were added by coupons (itemDiscount > 0)
    const manualProducts = cartData.filter(item => 
      (!item.itemDiscount || item.itemDiscount <= 0) && 
      (!item.freeCount || item.freeCount <= 0)
    );
    
    // Calculate subtotal only for manually added products
    const manualProductsSubtotal = manualProducts.reduce((sum, item) => {
      // Get the actual price considering size if available
      let itemPrice = item.sale_price || 0;
      
      // If item has size, use the size price instead of sale_price
      if (item?.size && item?.sizes?.length > 0) {
        const sizeItem = item.sizes.find((size) => size.id == item.size);
        if (sizeItem) {
          itemPrice = sizeItem.size_amount || itemPrice;
        }
      }
      
      const itemCount = item.count || 0;
      return sum + (itemPrice * itemCount);
    }, 0);
    
    // Calculate the total discount from coupon-added products
    const couponAddedProductsDiscount = cartData.reduce((sum, item) => {
      if (item.itemDiscount && item.itemDiscount > 0) {
        return sum + item.itemDiscount;
      }
      return sum;
    }, 0);
    
    return manualProductsSubtotal;
  };

  const checkCouponApplicability = (coupon) => {
    // const coupon = cart?.selectedCoupon;
    const checkoutDetails = cart?.checkoutDetails;
    const data = cart?.data;
    
 

    if (!coupon || !checkoutDetails || !data?.length) return false;

    const rules = coupon.rules || {};
    const applicableItemsFromCoupon = Array.isArray(coupon.items)
      ? coupon.items
      : JSON.parse(coupon.items || "[]");
    
    // 🔍 USE MANUAL PRODUCTS SUBTOTAL FOR COUPON VALIDATION
    const manualProductsSubtotal = calculateManualProductsSubtotal(data, cart?.priceSummary?.subTotal);
    const subTotal = Number(manualProductsSubtotal || 0);
    const isWithinOrderValue =
      subTotal >= Number(rules.MIN_ORDER_VALUE) &&
      subTotal <= Number(rules.MAX_ORDER_VALUE);

    const isApplicableForOrder =
      rules.APPLICABLE_FOR === checkoutDetails?.orderType ||
      rules.APPLICABLE_FOR === "ALL";

    // const isValidType =
    //   rules.type === "CART_DISCOUNT" ||
    //   rules.type === "FREE_DELIVERY" ||
    //   (rules.type === "ITEM_DISCOUNT" && coupon?.result?.DISCOUNT === 100) ||
    //   (rules.type === "ITEM_DISCOUNT" &&
    //     coupon?.result?.DISCOUNT !== 100 &&
    //     data.some((item) => applicableItemsFromCoupon.includes(item.itemId))) ||
    //   (rules.type === "BUY_ONE_GET_ONE_FREE" &&
    //     data.some((item) => applicableItemsFromCoupon.includes(item.itemId)));
    const isProductAvailable = checkProductAvailability(
      coupon,
      checkoutDetails?.deliveryType === "ASAP"
        ? currentTime?.toDate()
        : formatDateToCheck(checkoutDetails?.deliveryTime)
    );

   

    return (
      isWithinOrderValue &&
      isApplicableForOrder &&
      // isValidType &&
      isProductAvailable
    );
  };

  const checkWalletPointsConditions = () => {
    let total_walletPoints = getTotalWalletPoints();
    let redem = getWalletRedemption();

    if (total_walletPoints && redem) {
      if (total_walletPoints > redem?.maximum_consumable_points) {
        return {
          status: false,
          message:
            "Your total wallet points exceed the maximum consumable points allowed.",
        };
      } else if (total_walletPoints < redem?.min_consumable_points) {
        return {
          status: false,
          message:
            "Your total wallet points are below the minimum consumable points allowed.",
        };
      } else if (total_walletPoints > userData?.wallet_points) {
        return {
          status: false,
          message:
            "Your total wallet points exceed your available wallet balance.",
        };
      } else {
        return {
          status: true,
          message: "All conditions are met.",
        };
      }
    } else {
      return {
        status: true,
        message: "All conditions are met.",
      };
    }
  };

  const checkCartWalletPointsRange = () => {
    const redum = getWalletRedemption();
    const cartWalletPoints = getWalletPointsFromCartProducts()?.walletPoints || 0;
   
    if (!redum || !cartWalletPoints) {
      return false;
    }
    
    const minPoints = redum?.min_consumable_points || 0;
    const maxPoints = redum?.maximum_consumable_points || 0;
    
    // Check if cart wallet points fall within the valid range
    return cartWalletPoints >= minPoints && cartWalletPoints <= maxPoints;
  };

  return {
    checkWalletPointsConditions,
    checkCartWalletPointsRange,
    getWalletRedemption,
    isPointIsMoreThanAvailable,
    isPointMoreThanMax,
    isPointLessThanMin,
    getPriceWithAvailableWalletPoints,
    PointsToRedeemIfMax,
    checkIsLoyalityProdCanApply,
    getWalletPointsFromCartPrice,
    getWalletPointsFromProductPrice,
    filterCartProductsLoyality,
    checkIsProductLoyalityApplied,
    getWalletPointsFromCartProducts,
    calculateTotalPrice,
    resetWalletProducts,
    checkIsWalletDiscountTypeIsOne,
    walletAmountOtherThanProd,
    walletPointsOtherThanProduct,
    splitDigits,
    walletPointsFromType2,
    hasWalletType2,
    RemoveItemCoupon,
    removeFreeItems,
    checkCouponApplicability,
    isWalletLimitReached,
    removeAllFreeItems,
  };
};

export default useWalletPoints;
